import {Component, OnInit, Input} from '@angular/core';
import {CommonService} from '@services/common.services';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'idp2-help-modal',
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.scss']
})
export class HelpModalComponent implements OnInit {
  result$: any;
  @Input()
  title: string;
  constructor(
    private activeModal: NgbActiveModal,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.commonService.getHelpTopic(1, 1, 'PasswordHelp').subscribe(data => {
      this.result$ = data;
    });
  }

  close(): void {
    this.activeModal.close();
  }
}
